import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "order-create",
  class: "min-w-full w-full z-20 overflow-auto bg-white rounded-lg shadow-xl"
}
const _hoisted_2 = { class: "flex flex-col gap-6 p-2 pt-5 mx-2 border-b" }
const _hoisted_3 = { class: "w-full flex items-center gap-2" }
const _hoisted_4 = { class: "text-lg text-left w-[120px]" }
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { class: "w-full flex items-center gap-2" }
const _hoisted_7 = { class: "text-lg text-left w-[120px]" }
const _hoisted_8 = { class: "text-lg text-left w-[120px]" }
const _hoisted_9 = {
  key: 0,
  class: "w-full flex items-center mb-10 gap-2"
}
const _hoisted_10 = { class: "text-lg text-left w-[120px]" }
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center showError"
}
const _hoisted_12 = { class: "flex flex-col gap-6 p-2 mx-2" }
const _hoisted_13 = { class: "w-full flex justify-between items-center gap-2" }

import {
  DIRECTION_DELIVERY,
  DIRECTION_PICKUP,
  loadingUnitRegex,
} from "@/utils/constants";
import { HtmlHTMLAttributes, reactive, ref } from "vue";
import AutoComplete from "../AutoComplete.vue";
import store from "@/store";
import { Terminal } from "@/data/interfaces/TerminalInterface";
import { useRouter } from "vue-router";
import { i18n } from "@/i18n/i18n";

interface FormValidation {
  loading_unit_formatted: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCreate',
  setup(__props) {

const router = useRouter();
const { t } = i18n.global;

let formValidations = reactive({
  loading_unit_formatted: { invalid: "false", rx: loadingUnitRegex },
});

const terminals = ref(
  store.state.OrderStore.terminals.map((terminal) => terminal.terminalName)
);
const order = ref({
  directionType: false as string | boolean,
  loading_unit_formatted: "",
  terminal: null,
  primaryReference: "",
  terminalName: "",
});
const showError = ref("");

const selectTerminal = (name: string) => {
  showError.value = "";
  order.value.terminal =
    store.state.OrderStore.terminals.find(
      (terminal: Terminal) => terminal.terminalName == name
    ) ?? null;
  order.value.terminalName = order.value?.terminal?.terminalName ?? "";
};

const validateInput = (
  input: string,
  rx: RegExp,
  formValidationsKey: keyof FormValidation
) => {
  if (input) {
    formValidations[formValidationsKey].invalid = `${!rx.test(input)}`;
  } else {
    formValidations[formValidationsKey].invalid = "true";
  }
  formValidations = { ...formValidations };
};

const showErrors = (formValidationsKey: keyof FormValidation) => {
  let errorType = "Save";
  return formValidations[formValidationsKey].invalid === "true"
    ? t(`order.error${errorType}`)
    : undefined;
};

const fieldEmpty = () => {
  let disabled = true;
  if (order.value.terminal) {
    // if user has deleted part or all of this field, make them type and select again
    if (order.value.terminalName != order.value.terminal.terminalName) {
      order.value.terminal = null;
    }
  }
  disabled =
    !order.value.directionType ||
    !order.value.terminal ||
    !order.value.primaryReference;

  if (order.value.directionType == DIRECTION_PICKUP) {
    disabled =
      !order.value.loading_unit_formatted ||
      formValidations.loading_unit_formatted.invalid === "true" ||
      !order.value.directionType ||
      !order.value.terminal ||
      !order.value.primaryReference;
  }

  return disabled;
};

const save = async () => {
  await store.dispatch("toggleLoading", true);
  if (fieldEmpty()) {
    showError.value = t("order.error_fields_missing");
    await store.dispatch("toggleLoading", false);
  } else {
    showError.value = "";
    try {
      await store.dispatch("OrderStore/saveOrder", order.value);
      await store.dispatch("toggleLoading", false);
      router.push("/");
    } catch (e) {
      if (e.message === "Order not found") {
        showError.value = t("order.error_not_found");
      } else {
        showError.value = t("order.error_technical");
      }
      await store.dispatch("toggleLoading", false);
    }
  }
};

const selectDirection = (event: HtmlHTMLAttributes) => {
  showError.value = "";
  order.value.directionType = event?.target?.value;
};

return (_ctx: any,_cache: any) => {
  const _component_db_select = _resolveComponent("db-select")!
  const _component_db_icon = _resolveComponent("db-icon")!
  const _component_db_button = _resolveComponent("db-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("order.directionType")) + ":", 1),
        _createVNode(_component_db_select, {
          onChange: selectDirection,
          modelValue: order.value.directionType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((order.value.directionType) = $event)),
          value: order.value.directionType,
          label: !order.value.directionType ? _ctx.$t('order.directionType') : '',
          class: "w-full hydrated text-gray-300"
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("option", { selected: "" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(DIRECTION_PICKUP), _unref(DIRECTION_DELIVERY)], (direction) => {
              return (_openBlock(), _createElementBlock("option", {
                key: direction,
                value: direction,
                selected: order.value.directionType == direction
              }, _toDisplayString(_ctx.$t(direction)), 9, _hoisted_5))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "value", "label"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("order.terminal")) + ":", 1),
        _createVNode(AutoComplete, {
          modelValue: order.value.terminalName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((order.value.terminalName) = $event)),
          options: terminals.value,
          placeholder: _ctx.$t('order.terminal'),
          onOnSelect: selectTerminal,
          icon: "close"
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex items-center gap-2", order.value.directionType !== _unref(DIRECTION_PICKUP) ? 'mb-10' : ''])
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("order.reference")) + ":", 1),
        _createVNode(AutoComplete, {
          modelValue: order.value.primaryReference,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((order.value.primaryReference) = $event)),
          placeholder: _ctx.$t('order.reference'),
          icon: "close"
        }, null, 8, ["modelValue", "placeholder"])
      ], 2),
      (order.value.directionType === _unref(DIRECTION_PICKUP))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("order.loading_unit")) + ":", 1),
            _createVNode(AutoComplete, {
              modelValue: order.value.loading_unit_formatted,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((order.value.loading_unit_formatted) = $event)),
                _cache[4] || (_cache[4] = 
            () =>
              validateInput(
                order.value.loading_unit_formatted,
                _unref(loadingUnitRegex),
                'loading_unit_formatted'
              )
          )
              ],
              placeholder: _ctx.$t('order.loading_unit'),
              ariainvalid: _unref(formValidations)['loading_unit_formatted'].invalid,
              "error-message": showErrors('loading_unit_formatted'),
              icon: "close"
            }, null, 8, ["modelValue", "placeholder", "ariainvalid", "error-message"])
          ]))
        : _createCommentVNode("", true),
      (showError.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
            _createVNode(_component_db_icon, {
              icon: "error",
              variant: "24-outline",
              lass: "hydrated"
            }),
            _createElementVNode("p", null, _toDisplayString(showError.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_db_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/'))),
          class: "w-full hydrated",
          variant: "secondary-solid"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("order.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_db_button, {
          onClick: save,
          class: _normalizeClass([fieldEmpty() ? 'disabled' : '', "w-full hydrated"]),
          variant: "brand-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("order.add")), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}
}

})